import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { separateMessageForInfoIcon } from "./../Constants/ComonStrings";

export const renderToolTip = (message = separateMessageForInfoIcon) => {
  return <Tooltip style={{alignSelf:'center', marginLeft:'5px'}} title={message}><InfoOutlinedIcon className="info-button" /></Tooltip>;
}
